// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1RJtv","questions":"styles_questions__8NnOa","footer":"styles_footer__25zpn"};